import $ from 'jquery'
import { format } from '../../utils/currency'

class Module {
  constructor ($module) {
    this.$container = $module
    this.$form = $module.find('form')
    this.$wallet = $module.find('#credit_loan_financialAccount')
    this.$walletSelector = $module.find('.credit_loan_financialAccount')
    this.$rate = $module.find('#credit_loan_rate')
    this.$rateSelector = $module.find('.js-choice-widget.credit_loan_rate')
    this.$amount = $module.find('#credit_loan_amount')
    this.$minAmount = $module.find('.js-min-amount')
    this.$totalAmount = $module.find('.js-total-amount')
    this.$submit = $module.find('.js-submit')
    this.periods = this.$rateSelector.data('periods')
    this.minAmount = this.$minAmount.data('min-amount')
    this.maxAmount = this.$minAmount.data('max-amount')

    this.bind()
  }

  bind () {
    let self = this

    this.$form.submit(function () {
      if (!self.validate(self.$rate.val(), self.toFloat(self.$amount.val()))) {
        return false
      }

      self.$amount.val(self.toFloat(self.$amount.val()))
    })

    this.$submit.click(function () {
      self.$form.submit()
    })

    this.$amount.on('keyup change', function () {
      self.$rate.trigger('change')
    })

    this.$walletSelector.dropdown('setItemHandler', function (e) {
      e.preventDefault()
      self.$wallet.val($(this).data('value')).trigger('change')
    })

    this.$walletSelector.find('.b-dropdown__item_regular').trigger('click')

    this.$rate.on('change', function () {
      let d = $(this).val(),
          amount = self.toFloat(self.$amount.val()),
          rate = self.getRate(d, amount),
          refundAmount = amount + (amount / 100 * rate)

      self.$totalAmount.html(format(Number(refundAmount.toFixed()), 'RUB'))
      self.validate(d, amount)
    })

    this.$rateSelector.dropdown('setItemHandler', function (e) {
      e.preventDefault()
      self.$rate.val($(this).data('value')).trigger('change')
    })

    this.$rateSelector.find('.b-dropdown__item_regular').trigger('click')
  }

  getRate (days, amount) {
    let period = this.periods[days]
    let rate = {}

    for (let i in period) {
      rate = period[i]

      if (rate.minAmount <= amount && (!rate.maxAmount || rate.maxAmount >= amount)) {
        return rate.rate
      }
    }

    return 0
  }

  toFloat (val) {
    val = parseFloat(val.replace(/\s+/g, '').replace(/,/, '.'))

    if (isNaN(val)) {
      return 0
    }

    return val
  }

  validate(days, amount) {
    let rate = this.getRate(days, amount),
        $error = this.$minAmount.closest('.form-group').find('.js-error')

    if ((!rate || amount > this.maxAmount)) {
      let msg = amount < this.minAmount
        ? this.$minAmount.data('min-error-msg').replace('{{ limit }}', this.minAmount)
        : this.$minAmount.data('max-error-msg').replace('{{ limit }}', this.maxAmount)

      if (!$error.length) {
        this.$minAmount.addClass('hidden').after('<div class="bottom-hint js-error">' + msg + '</div>')
      } else {
        $error.html(msg)
      }

      this.$submit.addClass('disabled')
    } else if (rate && amount <= this.maxAmount) {
      this.$minAmount.removeClass('hidden').closest('.form-group').find('.js-error').remove()
      this.$submit.removeClass('disabled')
    }

    return rate && amount <= this.maxAmount
  }
}

$(function () {
  $('.js-credit-request').each(function () {
    new Module($(this))
  })
})
